<section class="header-info">
  <div class="title-info" mat-dialog-title>
    <span>Lista de Atalhos</span>
  </div>

  <div class="modal-screen">
    <h3>Gerais</h3>
    <hr>

    <!--Coluna 1-->
    <div class="column">
      <table>
        <tr>
          <th class="tecla1"><p> Esc </p></th>
          <!--<p id="sinal">+</p>
          <th class="tecla2"><p> C </p></th> -->
          <th id="nome">
            Cancelar/Interromper
            <p id="descricao">Cancela ou Interrompe uma ação na plataforma </p>
          </th>
        </tr>
      </table>
    </div>

    <!--Coluna 2-->
    <div class="column">
      <table>
        <tr>
          <th class="tecla1"><p> Shift </p></th>
          <p id="sinal">+</p>
          <th class="tecla1"><p> F5 </p></th>
          <th id="nome">
            Limpar Armazenamento Local
            <p id="descricao">Limpa todas as informações do armazenamento local</p>
          </th>
        </tr>
      </table>
    </div>
  </div>
</section>
